import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './layout/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CustomerLayoutComponent } from './module/customer/customer-layout/customer-layout.component';
import { DriverLayoutComponent } from './module/driver/driver-layout/driver-layout.component';
import { InnerHeaderComponent } from './layout/inner-header/inner-header.component';
import { InnerFooterComponent } from './layout/inner-footer/inner-footer.component';
import { AboutUsComponent } from './layout/about-us/about-us.component';
import { ContactUsComponent } from './layout/contact-us/contact-us.component';
import { HowItWorksComponent } from './layout/how-it-works/how-it-works.component';
import { CareerComponent } from './layout/career/career.component';
import { InvestorComponent } from './layout/investor/investor.component';
import { SafetyComponent } from './layout/safety/safety.component';
import { HelpAndSupportComponent } from './layout/help-and-support/help-and-support.component';
import { CareerDetailComponent } from './layout/career-detail/career-detail.component';
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { BlogComponent } from './layout/blog/blog.component';
import { BlogDetailComponent } from './layout/blog-detail/blog-detail.component';
import { ChartsModule } from 'ng2-charts';
import { SocketService } from './shared/services/socket.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DeleteRequestUserComponent } from './layouts/delete-request-user/delete-request-user.component';
import { PrivacyPolicyComponent } from './layouts/privacy-policy/privacy-policy.component';
import { TermConditionComponent } from './layouts/term-condition/term-condition.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SiteLayoutComponent,
    CustomerLayoutComponent,
    DriverLayoutComponent,
    InnerHeaderComponent,
    InnerFooterComponent,
    AboutUsComponent, ContactUsComponent, HowItWorksComponent, CareerComponent,
    InvestorComponent, SafetyComponent, HelpAndSupportComponent, CareerDetailComponent,
    BlogComponent, BlogDetailComponent, DeleteRequestUserComponent, PrivacyPolicyComponent, TermConditionComponent
  ],
  imports: [
    BrowserModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true
    }),
    HttpClientModule,
    SharedModule,
    NgbModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ChartsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule 
  ],
  providers: [
    SocketService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
